import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as AlertSVG } from "go-core/images/svg/alert.svg";
import { ReactComponent as WarningAlertSVG } from "go-core/images/svg/warning-alert.svg";
import { OrganizationApi } from "../../../../services/Api/types";
import { getOrganizationAlerts } from "./utils";

interface Props {
	organization: OrganizationApi;
}

const OrganizationListAlerts = ({ organization }: Props) => {
	const { t } = useTranslation("admin");
	const alerts = getOrganizationAlerts(
		organization.license_expires_at,
		organization.license_type,
		organization.payment_date_due,
		t,
		true,
		organization.abused_access
	);
	const alertsStatus = alerts?.find((alert) => alert?.type === "DANGER") ? "DANGER" : "WARNING";

	return alerts?.filter((alert) => alert.title)?.length > 0 ? (
		<OverlayTrigger
			placement="top"
			overlay={
				<Tooltip id={`tooltip-organization-${organization.id}-alerts`}>
					<div className="d-flex flex-column">
						{alerts.map((alert, index) => (
							<span key={`organization-${organization.id}-alert-${index}`}>{alert.title}</span>
						))}
					</div>
				</Tooltip>
			}
		>
			{alertsStatus === "DANGER" ? <AlertSVG className="me-1" /> : <WarningAlertSVG className="me-1" />}
		</OverlayTrigger>
	) : (
		<></>
	);
};

export default OrganizationListAlerts;
